export default {
  modalTitle: 'Updated terms of use',
  acceptButton: 'Agree',
  declineButton: 'Refuse',
  language: 'Display language',
};
